import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { MatRadioChange } from '@cdw-ae/common-frontend-materials';

@Component({
  selector: 'lib-cdw-radio-button',
  templateUrl: './cdw-radio-button.component.html',
  styleUrls: ['./cdw-radio-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CdwRadioButtonComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CdwRadioButtonComponent implements ControlValueAccessor {
  @Input() value: unknown;

  @Input() checked = false;

  @Input() disabled = false;

  @Input() name!: string;

  @Output() valueChange = new EventEmitter<unknown>();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (value: unknown) => {
    // Placeholder for ControlValueAccessor - overridden by registerOnChange
  };

  onTouched = () => {
    // Placeholder for ControlValueAccessor - overridden by registerOnTouched
  };

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: unknown) {
    if (this.value === value) {
      this.checked = true;
    } else {
      this.checked = false;
    }
  }

  onRadioButtonChanged($event: MatRadioChange) {
    this.checked = $event.source.checked;
    this.onChange($event.value);
    this.onTouched();
    this.valueChange.emit($event.value);
  }
}
